

import { Link } from 'react-router-dom';
import { usePages } from '../../hooks/usePages';

import logo from '../../assets/images/menu/logo-jg.png';
import instagram from '../../assets/images/footer/instagram.svg';
import facebook from '../../assets/images/footer/facebook.svg';
import youtube from '../../assets/images/footer/youtube.svg';
import pinterest from '../../assets/images/footer/pinterest.svg';
import tiktok from '../../assets/images/footer/tiktok.svg';
import houzz from '../../assets/images/footer/houzz.svg'

import './styles.scss';
import Subscribe from '../subscribe';

const Footer = () => {
    const { customPages } = usePages();

    return (
        <div className='footer'>
            <div className='main'>
                <div className='content'>
                    <div className='col'>
                        <img className='logo' alt='' src={logo} />
                    </div>
                    <div className='col'>
                        <ul>
                            <li className='heading'>Shop</li>
                            <li><span><Link to="/shop">Shop</Link></span></li>
                            <li><span><Link to="/divergence">Table Builder</Link></span></li>
                            <li><span><Link to="/slabs">Slabs</Link></span></li>
                            <li><span><Link to="/bases">Bases</Link></span></li>
                            <li><span><Link to="/custom-design">Paramount Exclusive</Link></span></li>
                            {customPages && customPages.filter(page => page.menuOption === 'Shop').map((page) => (
                                <li key={page.id}>
                                    <span><Link to={`/page/${page.id}`}>{page.header}</Link></span>
                                </li>
                            ))}
                        </ul>

                        <ul>
                            <li className='heading'>Studio</li>
                            <li><span><Link to="/portfolio">Client Portfolio</Link></span></li>
                            <li><span><Link to="/jeffrey-greene">Jeffrey Greene</Link></span></li>
                            <li><span><Link to="/additional-services">Additional Services</Link></span></li>
                            {customPages && customPages.filter(page => page.menuOption === 'Studio').map((page) => (
                                <li key={page.id}>
                                    <span><Link to={`/page/${page.id}`}>{page.header}</Link></span>
                                </li>
                            ))}
                        </ul>

                        <ul>
                            <li className='heading'>Info</li>
                            <li><span><Link to="/media">Media</Link></span></li>
                            <li><span><Link to="/news">In the News</Link></span></li>
                            <li><span><Link to="/our-story">Our Story</Link></span></li>
                            <li><span><Link to="/contact">Contact</Link></span></li>
                            {customPages && customPages.filter(page => page.menuOption === 'Info').map((page) => (
                                <li key={page.id}>
                                    <span><Link to={`/page/${page.id}`}>{page.header}</Link></span>
                                </li>
                            ))}
                        </ul>

                        {customPages && customPages.filter(page => !page.menuOption || (page.menuOption !== 'Shop' && page.menuOption !== 'Studio' && page.menuOption !== 'Info')).length > 0 && (
                            <ul>
                                <li className='heading'>More</li>
                                {customPages.filter(page => !page.menuOption || (page.menuOption !== 'Shop' && page.menuOption !== 'Studio' && page.menuOption !== 'Info')).map((page) => (
                                    <li key={page.id}>
                                        <span><Link to={`/page/${page.id}`}>{page.header}</Link></span>
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>
                    <div className='col'>
                        <ul>
                            <li className='heading'>Studio Address</li>
                            <li>
                                <a href="https://www.google.com/maps?q=6162+Lower+York+Road,+New+Hope,+PA+18938" target="_blank" rel="noopener noreferrer">
                                    6162 Lower York Road, New Hope, PA 18938
                                </a>
                            </li>
                        </ul>

                        <ul>
                            <li className='heading'>Contact</li>
                            <li className='clickable'>E: <a href='mailto:Hello@paramountwoodco.com'>Hello@paramountwoodco.com</a></li>
                            <li className='clickable'>T: <a href='tel:(412) 587-4166'>(412) 587-4166</a></li>
                        </ul>

                        <ul>
                            <li className='heading'>Studio Hours</li>
                            <li>Mon - Wed 10:00am - 4:00pm</li>
                            <li>Thurs & Fri 10:00am - 6:00pm</li>
                            <li>Nights & Weekends by appointment</li>
                        </ul>
                    </div>
                    <div className='col'>
                        <Subscribe />
                    </div>
                </div>
            </div>

            <div className='sub'>
                <div className='content'>
                    <div className='socials'>
                        <a href='https://www.instagram.com/paramountwoodco/' rel="noreferrer" target='_blank'><img src={instagram} alt='Paramount Wood Co. Instagram' /></a>
                        <a href='https://www.facebook.com/ParamountWoodCo/' rel="noreferrer" target='_blank'><img src={facebook} alt='Paramount Wood Co. Facebook' /></a>
                        <a href='https://www.youtube.com/@paramountwoodco' rel="noreferrer" target='_blank'><img src={youtube} alt='Paramount Wood Co. Youtube' /></a>
                        <a href='https://pinterest.com/paramountwoodcoshop/' rel="noreferrer" target='_blank'><img src={pinterest} alt='Paramount Wood Co. Pinterest' /></a>
                        <a href='https://www.tiktok.com/@paramountwoodco' rel="noreferrer" target='_blank'><img src={tiktok} alt='Paramount Wood Co. TikTok' /></a>
                        <a href='https://www.houzz.com/pro/paramountwoodco' rel="noreferrer" target='_blank'><img src={houzz} alt='Paramount Wood Co. Houzz' /></a>
                    </div>
                    <div className='copyright'>Copyright ©{new Date().getFullYear()}, Paramount Wood Co.</div>
                </div>
            </div>
        </div>
    )
}

export default Footer;